// extracted by mini-css-extract-plugin
export default {"form":"Login_form__KZ0VK","wrapper":"Login_wrapper__TGGvi","label":"Login_label__9UHHK","title":"Login_title__24Tgb","bounceInLeft":"Login_bounceInLeft__7rXTX"};